"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileTypeLabels = void 0;
const files_1 = require("../core-model-schemas/files");
exports.FileTypeLabels = {
    [files_1.FileType.GENERAL]: 'General',
    [files_1.FileType.DISCLOSURE]: 'Disclosure',
    [files_1.FileType.COLLABORATOR]: 'Collaborators',
    [files_1.FileType.HOD]: 'Heads of Department',
    [files_1.FileType.DEAN]: 'Deans of Faculty',
    [files_1.FileType.DRD]: 'Director of Research and Development',
    [files_1.FileType.TTO_DIRECTOR]: 'TTO Director',
    [files_1.FileType.ASSESSMENT]: 'Assessment forms',
    [files_1.FileType.LICENSING]: 'Licensing',
    [files_1.FileType.PATENTS]: 'Patents',
    [files_1.FileType.FORM_ATTACHMENT]: 'Form attachments',
};
